import { Navigate, useLocation } from 'react-router-dom';
import { APICore } from 'helpers/api/apiCore';
import { useUser } from 'hooks';
import { useMemo } from 'react';
import { components } from 'react-select';

import type { AuthUserAuthenticated } from 'api/generated/model';

type CurrentLoginDTO = AuthUserAuthenticated;
export type { CurrentLoginDTO };

// Custom hook para centralizar a lógica de autenticação
const useAuth = () => {
  const location = useLocation();
  const [rawUser] = useUser();
  const currentLogin: CurrentLoginDTO | null = rawUser;
  
  const api = useMemo(() => new APICore(), []);
  const isAuth = useMemo(() => api.isUserAuthenticated(), [api]);

  return {
    location,
    currentLogin,
    isAuth,
    user: currentLogin?.user,
    tenant: currentLogin?.tenant,
    relationType: currentLogin?.relationType,
    relationData: currentLogin?.relationData,
  };
};

export default useAuth;
